import React, { useRef, useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { MultiSelect } from 'primereact/multiselect';
import { useHistory, useParams } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';

import api from '../api/api';

import '../layout/sass/_form.scss';
import { FormRomaneioItens } from './FormRomaneioItens';

import { TabelaRomaneioItens } from './TabelaRomaneioItens';

import { DialogPrintRomaneios } from './DialogPrintRomaneios';

/* eslint-disable array-callback-return */

export const FormRomaneio = ({ isEditing, isLoading, dados }) => {

    const history = useHistory();
    const { id } = useParams();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false)
    const [romaneios, setRomaneios] = useState([]);
    const [romaneiosItens, setRomaneiosItens] = useState([]);
    const [produtores, setProdutores] = useState(null);
    const [pessoa, setPessoa] = useState(null);
    const [pedras, setPedras] = useState([]);
    const [selectedPedras, setSelectedPedras] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [mensagem, setMensagem] = useState("");
    const [disabled, setDisabled] = useState(true);
    const [datas, setDatas] = useState([]);
    const [showFormRomaneios, setShowFormRomaneios] = useState(false);
    const [showPrintRomaneios, setShowPrintRomaneios] = useState(false);
    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);


    const schema = Yup.object().shape({
        dataEmissao: Yup
            .array().of(Yup.date().required("A Data da emissao é obrigatória")),
        divida: Yup
            .number()
            .required("A divida é obrigatório"),
        boletimId: Yup
            .number()
            .positive("O boletim deve ser selecionado")
            .integer("O boletim deve estar na lista"),
        pessoaId: Yup
            .number()
            .required("O produtor é obrigatório")
            .positive("O produtor deve ser selecionado")
            .integer("O produtor deve estar na lista")
    })

    const initialValues = {
        "dataEmissao": "",
        "divida": "",
        "pessoaId": "",
        "pessoa": "",
        "produtorNome": "",
        "itens": [],
        "pedras": []
    }

    function handleChangeData(e) {

        setDatas(e.value);
        setDisabled(false);
        formik.setFieldValue("pessoaId", null);
        setProdutos([]);
    }

    function handleOnBlur(e) {
        if (datas != null) {
            if (datas.length > 0) {

                api.post("pedras/livres", datas).then((response) => { setPedras(response.data) })

            }
        }
    }

    function dividaHandleOnBlur(e) {

        if (e.target.value > 0) {

            api.get(`romaneio/divida/${e.target.value}`).then((response) => {
                var divida = response.data;

                if (divida.valorPgto > 0) {
                    toast.current.show({ life: 4000, severity: 'success', summary: 'Dívida!', detail: `Contribuinte: ${divida.nomeContribuinte} Valor: ${divida.valorPgto}` });
                } else {
                    toast.current.show({ life: 4000, severity: 'warn', summary: 'Dívida!', detail: `Contribuinte: ${divida.nomeContribuinte} Valor: ${divida.valorPgto}` });
                }

            }).catch((error) => {

                toast.current.show({ life: 4000, severity: 'error', summary: 'Dívida!', detail: "Dívida não encontrada..." });
            });
        }
    }

    const listaPedras = (pedras) => {

        var tempPedras = ''


        for (let i = 0; i < pedras.length; i++) {
            if (i === 0) {
                tempPedras = pedras[i].pedrasNumero;
            } else {
                tempPedras = tempPedras + "," + pedras[i].pedrasNumero;
            }
        }

        return (

            <InputText
                id="textPedras"
                name="textPedras"
                disabled="true"
                className={classNames({ 'p-invalid': isFormFieldValid('divida') })}
                value={tempPedras}
            />

        )
    }

    const formik = useFormik({

        initialValues: initialValues,

        validationSchema: schema,

        enableReinitialize: true,

        onSubmit: async (data) => {
            setIsSubmiting(true)
            const listPedras = [];
            if (isEditing) {
                selectedPedras.map((pedra) => {
                    listPedras.push({ id: pedra.id, romaneioId: data.id, pedrasId: pedra.id, pedrasNumero: pedra.numero })
                })
            } else {
                selectedPedras.map((pedra) => {
                    listPedras.push({ pedrasId: pedra.id, pedrasNumero: pedra.numero })
                })
            }
            let produtor;
            produtores.map((p) => {
                if (p.id === formik.values.pessoaId) {
                    produtor = p
                }
            })
            data.pessoa = produtor;
            const response = await api.get(`pessoa/${formik.values.pessoaId}`);
            data.produtorNome = response.data.nome;
            data.pedras = listPedras;

            const romaneios = []

            datas.map((d) => {
                var tempRomaneio = Object.assign({}, data)
                tempRomaneio.dataEmissao = d;
                romaneios.push(tempRomaneio);
            })

            const tempRomaneiosItens = romaneiosItens.map((item) => {
                return ({
                    "produtoId": item.produtoId,
                    "quantidade": item.quantidade,
                    "produtoNome": item.produtoNome,
                    "boletimItensId": item.itensId
                }
                )

            })


            romaneios.map((item) => {
                item.itens = tempRomaneiosItens
            })

            try {

                romaneios.map(async (r) => {
                    const response = await api.get(`boletimitens/produtos/${formik.values.pessoaId}`)
                    // eslint-disable-next-line no-useless-concat
                    const itens = response.data.map((i) => { return { id: i.produtoId, produtoNome: i.produtoNome + ' - ' + i.produtoEmbalagem + ' - ' + ' Bol. ' + i.boletimId, itensId: i.id, inicioColheita: i.inicioColheita, fimColheita: i.fimColheita } });
                    // eslint-disable-next-line no-useless-concat
                    let itensPeriodo = itens.filter(i => new Date(r.dataEmissao).toISOString() >= i.inicioColheita && new Date(r.dataEmissao).toISOString() <= i.fimColheita)
                    if (itensPeriodo !== "") {
                        let tempItens = itensPeriodo.map((item) => { return ({ "produtoId": item.id }) })
                        let itens = r.itens;
                        let itens2 = itensIguais(itens, tempItens)
                        let data1 = {
                            dataEmissao: r.dataEmissao,
                            divida: r.divida,
                            itens: itens2,
                            pedras: r.pedras,
                            pessoa: r.pessoa
                        }
                        await api.post("romaneio", [data1]);

                    }
                })


                if (!isEditing) {

                    formik.resetForm()
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro concluído!', detail: `${data.produtorNome} adicionado(a) com sucesso` });

                    setTimeout(() => {
                        history.push('/romaneio')

                    }, 2000)

                }
                else {

                    setTimeout(() => {
                        history.push('/romaneio')

                    }, 2000)

                }
            }
            catch (error) {
                if (!isEditing)
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao cadastrar romaneio!', detail: "Verifique se a dívida já não está cadastrada em outro romaneio" });
                else
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao editar romaneio!', detail: "Verifique se a dívida já não está cadastrada em outro romaneio" });

            }

            setIsSubmiting(false)
        }
    })

    function itensIguais(array1, array2) {
        var itensIguais = [];
        for (var i = 0; i < array1.length; i++) {
            for (var j = 0; j < array2.length; j++) {
                if (array1[i].produtoId === array2[j].produtoId) {
                    itensIguais.push(array1[i]);
                    break;
                }
            }
        }
        return itensIguais;
    }


    const handleGetProdutorAll = async () => {
        const response = await api.get(`pessoa/produtorAll`);
        const tempProdutor = response.data.map(produtor => {
            var prod = { label: '', value: '' };
            prod.label = produtor.nome + " - " + produtor.cpfcnpj
            prod.value = produtor.id

            return prod
        })
        const produtor = response.data.map(produtor => {
            return ({
                "id": produtor.id,
                "nome": produtor.nome,
                "cpfcnpj": produtor.cpfcnpj,
                "celular": produtor.celular,
                "tipoId": produtor.tipoId,
                "tipoDescricao": produtor.tipoDescricao,
                "observacao": produtor.observacao
            }
            )
        })
        setPessoa(tempProdutor)
        setProdutores(produtor)

    }

    useEffect(() => {

        // handleGetBoletinsAll();
        handleGetProdutorAll();

        if (isEditing) {
            api.get(`romaneio/${id}`).then((response) => {

                var tempRomaneios = [Object.assign({}, response.data)];

                setRomaneios(tempRomaneios);

                var tempData = [response.data.dataEmissao];

                response.data.dataEmissao = tempData

                var tempProdutor = [response.data.pessoaId] + " - " + [response.data.pessoa.nome];

                response.data.produtorNome = tempProdutor;

                formik.setValues(response.data);

                const tempPedras = response.data.pedras.map((p) => { return { id: p.pedrasId, numero: p.pedrasNumero } })

                setSelectedPedras(tempPedras)


                const tempBoletinItens = response.data.itens.map((i) => { return { id: i.produtoId, produtoNome: i.produtoNome } })

                setProdutos(tempBoletinItens);


                const itens = response.data.itens.map((i) => { return { id: i.produtoId, produtoNome: i.produtoNome + ' - ' + i.produtoEmbalagem, itensId: i.id, quantidade: i.quantidade } });


                setRomaneiosItens(itens);


            });
        } else {

            if (dados !== undefined) {

                const tempPedras = [];

                const pedra = {

                    id: dados.pedraNumero.id,
                    numero: dados.pedraNumero.numero,
                    uso: null

                }

                tempPedras.push(pedra);


                api.post("pedras/livres", [dados.dataEmissao]).then((response) => { setPedras(response.data) });

                setDatas([dados.dataEmissao]);

                setSelectedPedras(tempPedras);

                setDisabled(false);

            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Função para formatar a data no padrão 'yyyy-mm-dd'
    const formatarData = (data) => {
        const dataObj = new Date(data); // Converte a string em objeto Date
        const ano = dataObj.getFullYear();
        const mes = String(dataObj.getMonth() + 1).padStart(2, '0'); // Mes começa em 0, então somamos 1
        const dia = String(dataObj.getDate()).padStart(2, '0'); // Adiciona 0 à frente do dia, se necessário
        return `${ano}-${mes}-${dia}`;
    };

    useEffect(() => {
        if (formik.values.pessoaId !== "") {
            api.get(`boletimitens/produtos/${formik.values.pessoaId}`).then((response) => {
                // eslint-disable-next-line no-useless-concat
                const itens = response.data.map((i) => { return { id: i.produtoId, produtoNome: i.produtoNome + ' - ' + i.produtoEmbalagem + ' - ' + ' Bol. ' + i.boletimId, itensId: i.id, inicioColheita: i.inicioColheita, fimColheita: i.fimColheita } });
                let itensPeriodo;
                

                if (datas !== null && datas !== "") {
                    // eslint-disable-next-line no-lone-blocks
                    
                    if (datas.length <= 1) {                        
                        itensPeriodo = itens.filter(i =>
                            formatarData(datas) >= formatarData(i.inicioColheita) && formatarData(datas) <= formatarData(i.fimColheita)
                        );
                    } else {                        
                        itensPeriodo = itens.filter(i =>
                            formatarData(datas[0]) >= formatarData(i.inicioColheita) && formatarData(datas[0]) <= formatarData(i.fimColheita)
                        );
                    }

                    
                    setProdutos(itensPeriodo);
                }
                if (itensPeriodo === "") {
                    setMensagem("Data de emissão fora do período de colheita dos produtos!");
                }

            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formik.values.pessoaId])    

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="top-right" />
            <div className="p-col-12" >
                <h2 className="p-mt-0">Romaneio</h2>
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0" id="Romaneio" >

                        <div className="p-field p-col-12 p-sm-4 p-md-2">
                            <label
                                htmlFor="dataEmissao"
                                className={classNames({ 'p-error': isFormFieldValid('dataEmissao') })}
                            >
                                Data Emissão
                            </label>
                            {
                                !isLoading ?
                                    !isEditing ?
                                        <BrCalendar
                                            id="dataEmissao"
                                            name="dataEmissao"
                                            selectionMode={true}
                                            value={datas}
                                            onChange={handleChangeData}
                                            onHide={handleOnBlur}
                                            placeholder={isEditing === true ? new Date(formik.values.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : ""}
                                            readonly={true}
                                            className={classNames({ 'p-invalid': isFormFieldValid('dataEmissao') })}
                                            yearRange={`1900:${new Date().getFullYear() + 1}`}
                                            disabled={isEditing ? false : true}

                                        />
                                        :
                                        <>
                                            <InputText
                                                id="dataEmissao"
                                                name="dataEmissao"
                                                disabled="true"
                                                className={classNames({ 'p-invalid': isFormFieldValid('dataEmissao') })}
                                                value={new Date(formik.values.dataEmissao).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}
                                            />
                                        </>


                                    :
                                    <Skeleton height="35px" />
                            }

                            {formik.errors.dataEmissao && formik.touched.dataEmissao &&
                                <ErrorValidationMessage message={formik.errors.dataEmissao} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-2">
                            <label
                                htmlFor="divida"
                                className={classNames({ 'p-error': isFormFieldValid('divida') })}
                            >
                                Divida
                            </label>
                            {
                                !isLoading ?
                                    <InputText
                                        id="divida"
                                        name="divida"
                                        type="number"
                                        className={classNames({ 'p-invalid': isFormFieldValid('divida') })}
                                        value={formik.values.divida}
                                        onChange={formik.handleChange}
                                        onBlur={dividaHandleOnBlur}
                                        disabled={isEditing ? true : false}
                                    />

                                    :
                                    <Skeleton height="35px" />
                            }

                            {formik.errors.divida && formik.touched.divida &&
                                <ErrorValidationMessage message={formik.errors.divida} />
                            }
                        </div>

                        {/* <div className="p-field p-col-12 p-sm-6">
                            <label
                                htmlFor="boletim"
                                className={classNames({ 'p-error': isFormFieldValid('boletim') })}
                            >
                                Boletim
                            </label>
                            {
                                !isLoading ?

                                    !isEditing ?
                                        <div style={{ position: 'relative' }}>
                                        <Dropdown
                                            id="boletimId"
                                            name="boletimId"
                                            options={boletins}
                                            filter={true}
                                            emptyMessage={"Nenhuma boletim encontrado"}
                                            optionLabel="nome"
                                            optionValue="id"
                                            placeholder="Selecione um boletim"
                                            className={classNames({ 'p-invalid': isFormFieldValid('boletimId') })}
                                            value={formik.values.boletimId}
                                            onChange={option => formik.setFieldValue("boletimId", option.value)}
                                            emptyFilterMessage={"Nenhum técnico encontrado"}
                                            disabled={disabled}
                                        />
                                        {/* <p style={pStyle}>Carregando Boletins</p>
                                        <ProgressSpinner
                                        style={spinnerStyle}
                                        /> }
                                        </div>
                                        :
                                        <InputText
                                            id="boletim"
                                            name="boletim"
                                            className={classNames({ 'p-invalid': isFormFieldValid('boletimId') })}
                                            value={formik.values.produtorNome}
                                            disabled={true}
                                        />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.boletimId && formik.touched.boletimId &&
                                <ErrorValidationMessage message={formik.errors.boletimId} />
                            }
                        </div>     */}

                        <div className="p-field p-col-12 p-sm-6">
                            <label
                                htmlFor="pessoa"
                                className={classNames({ 'p-error': isFormFieldValid('pessoa') })}
                            >
                                Produtor
                            </label>
                            {
                                !isLoading ?

                                    !isEditing ?
                                        <div style={{ position: 'relative' }}>
                                            <Dropdown
                                                id="pessoaId"
                                                name="pessoaId"
                                                options={pessoa}
                                                filter={true}
                                                emptyMessage={"Nenhum produtor encontrado"}
                                                placeholder="Selecione um produtor"
                                                className={classNames({ 'p-invalid': isFormFieldValid('pessoaId') })}
                                                value={formik.values.pessoaId}
                                                onChange={option => formik.setFieldValue("pessoaId", option.value)}
                                                emptyFilterMessage={"Nenhum produtor encontrado"}
                                                disabled={disabled}
                                            />
                                        </div>
                                        :
                                        <InputText
                                            id="pessoa"
                                            name="pessoa"
                                            className={classNames({ 'p-invalid': isFormFieldValid('pessoaId') })}
                                            value={formik.values.produtorNome}
                                            disabled={true}
                                        />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.pessoaId && formik.touched.pessoaId &&
                                <ErrorValidationMessage message={formik.errors.pessoaId} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-2">

                            <label
                                htmlFor="pedras"
                                className={classNames({ 'p-error': isFormFieldValid('pedras') })}
                            >
                                Pedras
                            </label>

                            {
                                !isLoading ?

                                    !isEditing ?

                                        <MultiSelect
                                            id="pedrasId"
                                            name="pedrasId"
                                            value={selectedPedras}
                                            options={pedras}
                                            optionLabel="numero"
                                            opttionId="id"
                                            //display="chip"
                                            filter={false}
                                            emptyMessage={"Nenhuma pedra encontrada"}
                                            placeholder="Selecione as pedras"
                                            onChange={(e) => { setSelectedPedras(e.value); console.log(e.value) }}
                                        //disabled={pedras === ''}
                                        />

                                        :

                                        <>

                                            {listaPedras(formik.values.pedras)}

                                        </>


                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.pedras && formik.touched.pedras &&
                                <ErrorValidationMessage message={formik.errors.pedras} />
                            }
                        </div>

                    </div>

                    {!isEditing ?
                        produtos && (
                            <FormRomaneioItens
                                visible={showFormRomaneios}
                                setVisible={setShowFormRomaneios}
                                romaneioItens={romaneiosItens}
                                setRomaneioItens={setRomaneiosItens}
                                produtos={produtos}
                                mensagem={mensagem}
                                setMensagem={setMensagem}
                            />
                        )
                        : <></>
                    }

                    <DialogPrintRomaneios
                        visible={showPrintRomaneios}
                        setVisible={setShowPrintRomaneios}
                        setRomaneios={setRomaneios}
                        romaneios={romaneios}
                    />

                    <br />

                    <div className="p-d-flex p-jc-end p-mr-1" id="RomaneioItens" >

                        <TabelaRomaneioItens romaneioItens={romaneiosItens} setRomaneioItens={setRomaneiosItens} />

                    </div>

                    <div className="p-formgrid p-grid p-fluid p-mx-5">
                        {
                            !isLoading ?
                                <Button
                                    label={isEditing ? 'Editar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                    style={isEditing ? { 'display': 'none' } : { 'display': 'block' }}
                                    disabled={!romaneiosItens.length}
                                />
                                :
                                <></>
                        }
                        <br />
                    </div>

                </form>
            </div>
        </div>

    );
}
